import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LookupsService {
  constructor(private http: HttpClient) {}

  getCompanyTypes() {
    return this.http.get(`${environment.api}company_types`);
  }

  getCompanySectors() {
    return this.http.get(`${environment.api}sectors`);
  }

  getAllLookups() {
    return this.http.get(`${environment.api}lookups`);
  }
}
